module.exports = __webpack_public_path__ + "img/16581287_L.815b2266.png";